import { render } from "./UpdateClaimDeclaration.vue?vue&type=template&id=35cebf69"
import script from "./UpdateClaimDeclaration.vue?vue&type=script&lang=js"
export * from "./UpdateClaimDeclaration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__